import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const NoPlanIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 71 71" {...props}>
      <circle
        cx="35.5"
        cy="35.5"
        r="34.75"
        fill="white"
        stroke={colors.light}
        strokeWidth="1.5"
      />
      <path
        d="M56.2272 29.7125C54.0172 26.7125 50.9972 27.49 49.2922 27.9775C49.4447 26.795 49.9297 25.035 51.4372 23.33C51.8947 22.8125 51.8447 22.0225 51.3272 21.565C50.8122 21.11 50.0247 21.15 49.5622 21.6725C48.7972 22.5375 48.2522 23.42 47.8422 24.27C47.2472 21.4175 44.5547 18.75 40.4997 18.75C40.4997 23.325 43.8872 26.1775 47.1147 26.2125C46.9372 26.8725 46.8247 27.4825 46.7747 27.995C45.0822 27.51 42.0072 26.675 39.7722 29.7125C37.6947 32.53 37.4272 36.14 39.0572 39.3625C40.7872 42.7875 44.2972 45 47.9997 45C51.6997 45 55.2122 42.7875 56.9422 39.365C58.5722 36.14 58.3047 32.53 56.2272 29.7125Z"
        fill="#C0C5CD"
      />
      <path
        d="M36.75 20H29.25C28.56 20 28 20.56 28 21.25C28 21.94 28.56 22.5 29.25 22.5H36.75C37.44 22.5 38 21.94 38 21.25C38 20.56 37.44 20 36.75 20Z"
        fill="#C0C5CD"
      />
      <path
        d="M36.75 25H29.25C28.56 25 28 25.56 28 26.25C28 26.94 28.56 27.5 29.25 27.5H36.75C37.44 27.5 38 26.94 38 26.25C38 25.56 37.44 25 36.75 25Z"
        fill="#C0C5CD"
      />
      <path
        d="M34.25 30H29.25C28.56 30 28 30.56 28 31.25C28 31.94 28.56 32.5 29.25 32.5H34.25C34.94 32.5 35.5 31.94 35.5 31.25C35.5 30.56 34.94 30 34.25 30Z"
        fill="#C0C5CD"
      />
      <path
        d="M50.5 20V17.5C50.5 16.12 49.38 15 48 15H25.5C24.12 15 23 16.12 23 17.5V47.5H19.25C18.5525 47.5 17.9975 48.0825 18 48.78C18.0175 52.215 20.8125 55 24.25 55H44.25C47.7025 55 50.5 52.2025 50.5 48.75V47.5H48V48.75C48 50.8175 46.3175 52.5 44.25 52.5C42.1825 52.5 40.5 50.8175 40.5 48.75C40.5 48.06 39.94 47.5 39.25 47.5H25.5V17.5H48V20H50.5Z"
        fill="#C0C5CD"
      />
      <path d="M11 54.0529L58.6191 19" stroke="white" strokeWidth="3" />
      <path
        d="M13.3809 55.3674L60.9999 20.3145"
        stroke="#C0C5CD"
        strokeWidth="3"
      />
    </SvgIcon>
  );
};

export default NoPlanIcon;
